// extracted by mini-css-extract-plugin
module.exports = {"placeholder":"FJMediaItemPlaceholder_placeholder__1zSfA","progress":"FJMediaItemPlaceholder_progress__1v8Kt"};